require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-dan-scott-eclipse-music-events.json") })
        }
      }, "path---interview-dan-scott-eclipse-music-events");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-dan-scott-eclipse-music-events!./.cache/json/interview-dan-scott-eclipse-music-events.json
// module id = 665
// module chunks = 231608221292675